/**
 * Loại cột - xác định editor
 */
export default {
    None: 0,//Không chọn
    EstimateAdvance: 2,//Tạm ứng đã cấp dự toán
    EstimateNotYetAdvance: 3,//Tạm ứng chưa cấp dự toán
    AdvancePayment: 4,//Thanh toán tạm ứng
    Expense: 6,//Thực chi,sửa theo comment của a tú
    PlanReceipt: 7,//Nhập dự toán
    TreasuryWarrantReceipt: 8,//Nhận lệnh chi tạm ứng
    ReceiptExpense: 9,//Ghi thu - Ghi chi
    TreasuryWarrantReceiptExpense: 10,//Nhận lệnh chi thực chi
    ExpenseReduce: 12,//Giảm chi - Thực chi
    ExpenseReduceAdvance: 13,//Giảm chi - Tạm ứng
    RefundExpense: 15,//Nộp trả - Thực chi
    RefundAdvance: 16,//Nộp trả - Tạm ứng
    Supplement: 24,//Bổ xung
    RestoreExpense: 30,//Khôi phục - Thục chi
    RestoreAdvance: 31,//Khôi phục - Tạm ứng
    BudgetRejecttion: 33,//Xuất toán
    ReceiptBudgetReturn: 36,//Giảm thu
    IncrementAdjustment: 39,//Điều chỉnh tăng thuế GTGT
    DecrementAdjustment: 42,//Điều chỉnh giảm thuế GTGT
    DestroyPlanning: 45,//Hủy dự toán
    BUPlanAdjustment: 46,//Điều chỉnh dự toán
    DestroyReceipt: 50,//Hủy lệnh chi tiền
    ReceiptForInferior: 60,//Lệnh chi cho cấp dưới
    ReceivedReceiptFromSuperiors: 61,//Lệnh chi nhận từ cấp trên
};
